import { Injectable } from '@angular/core';
import { LoadingController, AlertController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { VariablesService } from './variables.service';
import { globalConf } from '../Modelos/GlobalConf';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { stringify } from 'querystring';
import { TransccionesAloREto } from '../Modelos/transaccionesAloReto';
import * as CryptoJS from 'crypto-js';
import { Almacen } from '../Modelos/almacen';
import { Provincia } from '../Modelos/provincia';
import { Poblacion } from '../Modelos/poblacion';


@Injectable({
  providedIn: 'root'
})
export class ServiciosService {
  loadingObject: HTMLIonLoadingElement;

  constructor(
    private loadingCtrl: LoadingController,
    private alertController: AlertController,

    private variables: VariablesService,
    public http: HttpClient

  ) {
    this.provincias();
    this.poblaciones();
   }

  desencriptarAES(valorEncriptado: string, key: string) {
    // ENCRIPTA LA KEY A UTF8 Y LA IV
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = CryptoJS.enc.Utf8.parse(key);
    let decrypted = CryptoJS.AES.decrypt(valorEncriptado, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    // SE CODIFICA A BASE64
    decrypted = decrypted.toString(CryptoJS.enc.Base64)

    // SE PASA A ARRAY DE BYTES Y SE ELIMINAN LOS 16 PRIMEROS BYTES
    let arrayBytes = base64ToByteArray(decrypted);
    let array: Uint8Array = arrayBytes[0];
    let arrayReducido = array.slice(16, array.length)

    // SE DESENCRIPTA EL ARRAY DE BYTES A UTF8
    let valorDesencriptado = stringFromUTF8Array(arrayReducido);
    return valorDesencriptado;
    function stringFromUTF8Array(data) {
      const extraByteMap = [1, 1, 1, 1, 2, 2, 3, 0];
      var count = data.length;
      var str = "";

      for (var index = 0; index < count;) {
        var ch = data[index++];
        if (ch & 0x80) {
          var extra = extraByteMap[(ch >> 3) & 0x07];
          if (!(ch & 0x40) || !extra || ((index + extra) > count))
            return null;

          ch = ch & (0x3F >> extra);
          for (; extra > 0; extra -= 1) {
            var chx = data[index++];
            if ((chx & 0xC0) != 0x80)
              return null;

            ch = (ch << 6) | (chx & 0x3F);
          }
        }

        str += String.fromCharCode(ch);
      }

      return str;
    }

    function base64ToByteArray(base64String) {
      try {
        var sliceSize = 1024;
        var byteCharacters = atob(base64String);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
          var begin = sliceIndex * sliceSize;
          var end = Math.min(begin + sliceSize, bytesLength);

          var bytes = new Array(end - begin);
          for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
          }
          byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return byteArrays;
      } catch (e) {
        console.log("Couldn't convert to byte array: " + e);
        return;
      }
    }

  }

  async presentLoading(mensaje?: string) {

    if (!this.loadingObject) {

      if (mensaje != null) {
        this.loadingObject = await this.loadingCtrl.create({
          message: mensaje
        })
        await this.loadingObject.present();

      } else {
        this.loadingObject = await this.loadingCtrl.create()
        await this.loadingObject.present();
      }
    }
  }

  async dissmisLoading() {
  if (this.loadingObject) {
    this.loadingCtrl.dismiss()
    this.loadingObject = null;
  };

}

  async presentAlert(hearder: string, subhearder: string, message ?: string, buttons ?: string) {

  if (buttons == null) buttons = "De acuerdo";
  const alert = await this.alertController.create({
    header: hearder,
    subHeader: subhearder,
    message: '<div style="overflow-y:scroll;">'+message+'</div>',
    buttons: [buttons]
  });

  await alert.present();
}

  async presentAlertConfirm(hearder: string, subhearder: string, message: string): Promise < boolean > {
  let resultado: boolean
    const alert = await this.alertController.create({
    // cssClass: 'my-custom-class',
    header: hearder,
    subHeader: subhearder,

    message: message,
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'secondary',
        handler: (blah) => {
          console.log('Confirm Cancel: blah');
          resultado = false;
          return resultado
        }
      }, {
        text: 'Confirmar',
        handler: () => {
          console.log('Confirm Okay');

          resultado = true;
          return resultado;
        }
      }
    ]
  });

  await alert.present();

  return await alert.onDidDismiss().then(() => { return resultado })
}

obtenerListadoEmpresas(usuario, pwd): Observable < any > {
  console.log('En el servicio login');
  let body;
  body = { usuario: usuario, pwd: pwd };

  const parametros = new HttpParams()
    .set('filtroModulo', 'FITO')

    //console.log('En el servicio login', body);
    const cabecera = new HttpHeaders()
    .set('Authorization', 'Bearer ' + this.variables.tokenLogin.access_token)
    .set('Content-Type', 'application/json');
  //console.log("cabecera " + cabecera.get('Authorization'));
  //console.log('cabecera ' + cabecera.get('Content-Type'));


  return this.http.get(
    globalConf.url_api_presencia + globalConf.path_Login_listadoEmpresas,

    { params: parametros }
  );
}

obtenerTransaccionesAlo(fechaInicial: string, fechaFinal: string): Observable < TransccionesAloREto > {

  const parametros = new HttpParams()
    .set('FechaDesde', fechaInicial)
    .set('FechaHasta', fechaFinal)
    .set('GUID_Empresa', this.variables.empresaSeleccionada.GUID_Empresa)
    .set('Estado', this.variables.filtroEstado)
    .set('CodigosOperacion', this.variables.filtroCodigo)
    .set('Almacenes', this.variables.filtroAlmacen)
    .set('CodigosROPO', this.variables.filtroROPO)

    return this.http.get(globalConf.url_api_presencia + globalConf.path_documentosRetoCrecenciaAlo, { params: parametros }) as Observable<TransccionesAloREto>;

}

obtenerCredencialesRETO() {
  return this.http.get(globalConf.url_api_presencia + globalConf.path_credeciales_RETO, { params: this.setParamtroGUID_Empresa() });
}

getAlmacenesReto() {

  return this.http.get(globalConf.url_api_presencia + globalConf.path_AlmacenesRopo, { params: this.setParamtroGUID_Empresa() }) as Observable<Almacen[]>

}


setParamtroGUID_Empresa() {
  const parametros = new HttpParams()
    .set('GUID_Empresa', this.variables.empresaSeleccionada.GUID_Empresa)
  return parametros
}

putTransaccionAlo(tipoDocumento: number, id_Documento: number, id_Transaccion: number, horaTransaccion: string, Resultado: string) {
  const parametros = new HttpParams()
    .set('GUID_Empresa', this.variables.empresaSeleccionada.GUID_Empresa)
  let body = [{
    "Tipo_Documento": tipoDocumento,
    "Id_Documento": id_Documento,
    "Id_Transaccion": id_Transaccion,
    "Hora_Transaccion": horaTransaccion,
    "Resultado": Resultado
  }]

  return this.http.put(globalConf.url_api_presencia + globalConf.path_documetosRetoTokenEmpresa, body, { params: parametros }) as Observable<TransccionesAloREto>;
}

provincias()  {
  this.http.get('../../assets/datos/provincias.json').subscribe(
    (next : Provincia[]) => {
      this.variables.provincias = next;
      console.log("Procincias " , this.variables.provincias)
    },
    error => {
      console.log( " error servicio provincias " , error)
    })
  }

poblaciones()  {
  this.http.get('../../assets/datos/poblaciones.json').subscribe(
    (next : Poblacion[]) => {
      this.variables.poblaciones = next;
      console.log("Poblaciones  " , this.variables.poblaciones)
    },
    error => {
      console.log( " error servicio poblaciones " , error)
    })  
  
}




}
